export const tableFieldsStyle = {
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		gap: '12px',
	},

	title: {
		textTransform: 'capitalize',
		// width: '86px !important',
		marginTop: '16px',
	},

	table: {
		maxWidth: '1074px',
		tableLayout: 'fixed',
	},

	tableHeader: {
		'& > :nth-of-type(1)': {
			width: '8%',
			textTransform: 'capitalize',
			whiteSpace: 'nowrap',
		},
		'& > :nth-of-type(2)': {
			width: '15%',
		},
		'& > :nth-of-type(3)': {
			width: '15%',
		},
		'& > :nth-of-type(4)': {
			width: '19%',
			textTransform: 'capitalize',
		},
		'& > :nth-of-type(5)': {
			width: '15%',
		},
		'& > :nth-of-type(6)': {
			width: '19%',
		},
		'& > :nth-of-type(7)': {
			width: '6%',
			textTransform: 'uppercase',
		},
		'& > :nth-of-type(8)': {
			width: '3%',
			textTransform: 'uppercase',
		},
	},

	tableFields: {
		display: 'flex',
		alignItems: 'center',

		'& > :nth-of-type(1)': {
			width: '8%',
			paddingLeft: '16px',
		},
		'& > :nth-of-type(2)': {
			width: '15%',
		},
		'& > :nth-of-type(3)': {
			width: '15%',
		},
		'& > :nth-of-type(4)': {
			width: '19%',
		},
		'& > :nth-of-type(5)': {
			width: '17%',
		},
		'& > :nth-of-type(6)': {
			width: '19%',
		},
		'& > :nth-of-type(7)': {
			width: '4%',
			marginTop: '16px',
		},
		'& > :nth-of-type(8)': {
			width: '3%',
			marginTop: '16px',

			'& .MuiButtonBase-root': {
				padding: 'unset',
			},
		},
		'& > :not(:last-of-type)': {
			padding: '0 8px',
		},
	},

	menuItem: {
		width: '100%',
		padding: '8px 16px',
		cursor: 'pointer',

		'&:hover': {
			backgroundColor: 'var(--background-grey-op-50-1)',
		},
	},
	menuDisableItem: {
		color: 'var(--neutral-300)',
	},
};
